/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EmploymentAndTaxDetailsViewModel,
  ErrorResult,
  NotFoundErrorResult,
  Result,
  ResultOfEmploymentAndTaxDetailsViewModel,
  ValidationErrorResult,
} from '../models';
import {
    EmploymentAndTaxDetailsViewModelFromJSON,
    EmploymentAndTaxDetailsViewModelToJSON,
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfEmploymentAndTaxDetailsViewModelFromJSON,
    ResultOfEmploymentAndTaxDetailsViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface EmploymentAndTaxGetRequest {
    proposalId: number;
}

export interface EmploymentAndTaxPostRequest {
    proposalId: number;
    employmentAndTaxDetailsViewModel: EmploymentAndTaxDetailsViewModel;
}

/**
 * 
 */
export class EmploymentAndTaxApi extends runtime.BaseAPI {

    /**
     * Gets the employment and tax details for a party.
     */
    async employmentAndTaxGetRaw(requestParameters: EmploymentAndTaxGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfEmploymentAndTaxDetailsViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling employmentAndTaxGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/employment-and-tax/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfEmploymentAndTaxDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Gets the employment and tax details for a party.
     */
    async employmentAndTaxGet(requestParameters: EmploymentAndTaxGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfEmploymentAndTaxDetailsViewModel> {
        const response = await this.employmentAndTaxGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Posts the specified employment and tax details view model.
     */
    async employmentAndTaxPostRaw(requestParameters: EmploymentAndTaxPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling employmentAndTaxPost.');
        }

        if (requestParameters.employmentAndTaxDetailsViewModel === null || requestParameters.employmentAndTaxDetailsViewModel === undefined) {
            throw new runtime.RequiredError('employmentAndTaxDetailsViewModel','Required parameter requestParameters.employmentAndTaxDetailsViewModel was null or undefined when calling employmentAndTaxPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/employment-and-tax/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmploymentAndTaxDetailsViewModelToJSON(requestParameters.employmentAndTaxDetailsViewModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Posts the specified employment and tax details view model.
     */
    async employmentAndTaxPost(requestParameters: EmploymentAndTaxPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.employmentAndTaxPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
